export default __webpack_public_path__ + "static/media/3484.74502fdf.svg";